import PageHeader from "../components/PageHeader";

const SECTIONS = [
  {
    h: "1. Acceptance of terms",
    p: 'By accessing or using the DN Flooring, Interior Design website ("Site") or by requesting services from DN Flooring ("we," "our," or "us"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Site.',
  },
  {
    h: "2. Services",
    p: "DN Flooring provides residential remodeling services including flooring installation, cabinetry, tile work, painting, drywall, carpentry, stairs, doors, and interior design across Manatee, Sarasota, and Charlotte County, Florida. The Site provides general information about our services and a way to request quotes.",
  },
  {
    h: "3. Quotes & estimates",
    p: "All quotes provided through this website or otherwise are estimates based on the information you provide. Final pricing may vary depending on a physical site assessment, material availability, and scope changes. A signed written agreement is required before any work begins.",
  },
  {
    h: "4. No warranty on website content",
    p: 'The Site and its contents are provided "as is." We make no warranties, express or implied, regarding the accuracy, completeness, or availability of the Site. Photos shown represent representative work and may not match the exact materials or finishes available at the time of your project.',
  },
  {
    h: "5. Limitation of liability",
    p: "To the maximum extent permitted by Florida law, DN Flooring shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of the Site. Our total liability for any claim relating to the Site is limited to one hundred U.S. dollars ($100).",
  },
  {
    h: "6. Project-related agreements",
    p: "Any actual work performed by DN Flooring is governed by a separate written contract executed between you and DN Flooring. Those contract terms — not these website Terms — control the scope, price, warranty, and dispute resolution for the work itself.",
  },
  {
    h: "7. Intellectual property",
    p: "All content on the Site — text, graphics, logos, images, and design — is owned by or licensed to DN Flooring and is protected by U.S. copyright and trademark laws. You may not reproduce or use this content without written permission.",
  },
  {
    h: "8. User submissions",
    p: "Information you submit through the quote or contact form must be accurate and lawful. You grant us a non-exclusive license to use that information to respond to your request and provide services.",
  },
  {
    h: "9. Third-party links",
    p: "The Site may contain links to third-party services (e.g., Instagram, Facebook, Google). We are not responsible for the content or privacy practices of those third parties.",
  },
  {
    h: "10. Governing law",
    p: "These Terms are governed by the laws of the State of Florida. Any dispute arising out of these Terms or your use of the Site shall be brought exclusively in the state or federal courts located in Manatee County, Florida.",
  },
  {
    h: "11. Changes",
    p: "We may update these Terms at any time. Continued use of the Site after a change constitutes acceptance of the updated Terms.",
  },
  {
    h: "12. Contact us",
    p: "Questions about these Terms? Email Dn1floor@gmail.com or call (941) 626-5241.",
  },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function TermsPage() {
  return (
    <main data-testid="terms-page">
      <PageHeader
        eyebrow="Legal"
        title="Terms of Service."
        accent="The fine print."
      />

      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
            {/* TOC */}
            <aside className="lg:col-span-4 lg:sticky lg:top-28 h-fit">
              <div className="rounded-lg border border-white/5 bg-[#2a3744] p-6">
                <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-4">
                  Contents
                </div>
                <nav>
                  <ul className="space-y-2.5">
                    {SECTIONS.map((s) => (
                      <li key={s.h}>
                        <a
                          href={`#${slug(s.h)}`}
                          className="text-[13px] text-slate-400 hover:text-white transition-colors"
                        >
                          {s.h}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
                <div className="mt-6 pt-5 border-t border-white/10 text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  Last updated: April 2026
                </div>
              </div>
            </aside>

            {/* Body */}
            <div className="lg:col-span-8 space-y-10">
              {SECTIONS.map((s) => (
                <div key={s.h} id={slug(s.h)} className="scroll-mt-28">
                  <h2 className="font-serif text-xl sm:text-2xl text-white tracking-tight leading-tight">
                    {s.h}
                  </h2>
                  <p className="mt-3 text-[15px] text-slate-300 leading-[1.75]">
                    {s.p}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
